'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react'

interface CarJourney {
  data: string[]
}

interface CarJourneyContextType {
  carJourney: CarJourney | null
  setCarJourney: (carJourney: CarJourney | null) => void
}

const CarJourneyContext = createContext<CarJourneyContextType>({
  carJourney: null,
  setCarJourney: () => { }
})

interface CarJourneyProviderProps {
  children: ReactNode
  initialValue?: CarJourney | null
}

export const CarJourneyProvider = ({ children, initialValue = null }: CarJourneyProviderProps) => {
  const [carJourney, setCarJourney] = useState<CarJourney | null>(initialValue)

  return (
    <CarJourneyContext.Provider value={{ carJourney, setCarJourney }}>
      {children}
    </CarJourneyContext.Provider>
  )
}

export const useCarJourney = (): CarJourneyContextType => {
  const context = useContext(CarJourneyContext)
  if (!context) {
    throw new Error('useCarJourney must be used within a CarJourneyProvider')
  }
  return context
}
